import type { TrackingMessageAction } from "./constants.ts";
import { TRACKING_MESSAGE_ACTIONS } from "./constants.ts";
import { getEnteredByLabel } from "./get-entered-by-label.ts";

const normalizeName = (name: string | null | undefined) =>
	name?.trim().toLowerCase() ?? "";

// Freight Core only lets the author edit a tracking message, so Edit is offered
// on the current user's own messages. Any message can be deleted, including
// system (SMC3/RPA) updates and other users' messages.
export const getTrackingMessageActions = (
	enteredBy: string | null | undefined,
	currentUserName: string | null | undefined,
): TrackingMessageAction[] => {
	const author = getEnteredByLabel(enteredBy);
	const currentUser = normalizeName(currentUserName);
	const isOwnMessage =
		author != null &&
		!author.isSystem &&
		currentUser !== "" &&
		normalizeName(author.label) === currentUser;

	return isOwnMessage
		? [TRACKING_MESSAGE_ACTIONS.edit, TRACKING_MESSAGE_ACTIONS.delete]
		: [TRACKING_MESSAGE_ACTIONS.delete];
};
